import React, {FC} from 'react';

import {Dropdown} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {PrescriptionType} from 'mobile/pages/success/fixtures/checkout/checkoutTypes';

import {updateCartItem} from '../../store/reducers/changeItemQty/changeItemQty';
import {AddToCartPrescriptionType, AddToCartType} from '../../types/quoteItem';

import s from './selectLensesCount.scss';

export type PropsType = {
    prescription: PrescriptionType;
    side: 'od' | 'os';
    itemId: string;
    isDisabled?: boolean;
    updateItem: (data: {data: AddToCartType; quoteType?: string}) => void;
};

/**
 * Select for lenses count
 */
export const SelectLensesCount: FC<PropsType> = ({
    isDisabled,
    itemId,
    prescription,
    side,
    updateItem,
}) => {
    const oppositeSide = side === 'od' ? 'os' : 'od';
    const array = [
        ...(Number(prescription[oppositeSide]?.boxes) === 0 ? [] : [0]),
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
    ];
    const onChange = (value: React.ReactNode) => {
        const boxes = Number(value);

        updateItem({
            data: {
                prescription: {
                    ...(prescription as unknown as AddToCartPrescriptionType),
                    [side]: {
                        ...prescription[side],
                        boxes,
                    },
                },
                qty: Number(prescription[oppositeSide]?.boxes) + boxes,
                quoteItemId: itemId,
            },
        });
    };

    return (
        <Dropdown
            classes={{container: s.selectContainerRedesign}}
            data-test-name="boxDropdown"
            disabled={isDisabled}
            onClick={onChange}
            options={array.map(value => ({label: String(value), value}))}
            selectedValue={Number(prescription[side]?.boxes)}
            size="extraSmall"
        />
    );
};

export const SelectLensesCountConnected = connect(null, {
    updateItem: updateCartItem,
})(SelectLensesCount);
